module.exports = __webpack_public_path__ + "static/media/2B.53cffd6a.png";